{
  "labels": {
    "searching": "Searching...",
    "declines": "Declines",
    "monitored": "Monitored",
    "unmonitored": "Unmonitored",
    "programmeManager": "Programme Manager",
    "binSponsor": "BIN Sponsor",
    "ruleSetDetails": "Ruleset Details",
    "selectProgrammeManager": "Select Programme Manager"
  },
  "errors": {
    "noTransactionsFound": "No Transactions Found"
  },
  "components": {
    "home": {
      "welcomeBack": "Welcome back, {{displayName}}",
      "subtitle": "Search cards, track transactions, and explore all the tools Thredd Portal offers.",
      "homeSearch": {
        "shared": {
          "labels": {
            "tokenId": "Token ID"
          },
          "placeholders": {
            "cardToken": "Card Token (9 or 16 digits)"
          },
          "errors": {
            "tokenNotFound": "Token not found",
            "invalidToken": "Invalid token number - Try again",
            "unexpectedError": "An unexpected error occurred."
          }
        },
        "cards": {
          "labels": {
            "customerReference": "Customer Reference"
          },
          "placeholders": {
            "customerReference": "Between 1-25 alphanumeric characters",
            "productId": "Product ID (UUID)"
          },
          "actions": {
            "advancedCardsSearch": "Advanced Cards Search →"
          }
        },
        "transactions": {
          "labels": {
            "traceId": "Trace ID"
          },
          "tooltips": {
            "tokenId": "Thredd Public Token - {{minLength}} or {{maxLength}} digit number",
            "transactionId": "Unique Transaction ID"
          },
          "errors": {
            "transactionIdNotFound": "Transaction ID not found"
          },
          "actions": {
            "advancedTransactionSearch": "Advanced Transaction Search →"
          }
        }
      }
    },
    "searchScreen": {
      "title": "Card & Transactions",
      "tabs": {
        "cards": "Cards"
      },
      "searchQueries": {
        "token": "Token",
        "transactionId": "Transaction Id"
      },
      "transactions": {
        "filters": {
          "dateAndTime": "Date and Time"
        },
        "columns": {
          "dateAndTime": "Date & Time",
          "transactionStatus": "Transaction Status",
          "networkType": "Network Type",
          "fixedFee": "Fixed Fee",
          "rateFee": "Rate Fee",
          "fxPadding": "FX Padding",
          "mcc": "MCC",
          "paymentMethod": "Payment Method"
        },
        "cardTypes": {
          "mfx": "MFX",
          "regular": "Regular"
        },
        "actions": {
          "exporting": "Exporting..."
        },
        "errors": {
          "transactionSearchTimeout": "Transaction search timeout.",
          "errorNotificationDescription": "An Error has occurred"
        },
        "moreFilters": {
          "categories": {
            "currencyAndAmounts": "Currency and Amounts",
            "processingAndOperational": "Processing and Operational"
          },
          "merchant": {
            "locationLabel": "Merchant Location"
          },
          "amounts": {
            "billingAmountPlaceholder": "Bill Amount"
          },
          "processing": {
            "processingCodePlaceholder": "All Processing Codes"
          }
        }
      }
    },
    "panFinder": {
      "title": "Thredd PAN Finder",
      "mfaModalTitle": "Multi-factor authentication",
      "mfaInputPlaceholder": "Enter Code",
      "mfaSendCodeButton": "Send Code",
      "selectSearchType": "Select search type",
      "publicTokenLabel": "Public Token:",
      "publicTokenValidation": "The value must be 9 or 16 digits long",
      "panValidation": "The value must be 16 digits long",
      "searchResults": "Search Results",
      "panLabel": "PAN:",
      "pubToken9Digit": "Public Token (9-Digit):",
      "pubToken16Digit": "Public Token (16-Digit):",
      "timerMessage": "These results will clear in {{timeLeft}} seconds."
    },
    "salesCalculator": {
      "title": "Calculator",
      "calculateReconciliationSavings": "Calculate Reconciliation Savings",
      "calculateCostPlaceholder": "Calculate cost per how many transactions?",
      "monthlyManualReconciliationCost": "Monthly manual reconciliation cost savings:",
      "calculateNetworkSavings": "Calculate Network Savings",
      "weeklyNetworkCostsPlaceholder": "Client existing weekly network costs? ($)",
      "monthlyNetworkCostsPlaceholder": "Client existing monthly network costs? ($)",
      "networkSavings": "Network savings:",
      "perWeek": "Per week:",
      "perMonth": "Per month:"
    },
    "abo": {
      "title": "ABO",
      "description": "Access and manage automated back office services.",
      "sections": {
        "activityReconciliation": {
          "category": "Activity Reconciliation",
          "description": "Reconcile activity across all accounts and programs."
        },
        "transactionMatching": {
          "category": "Transaction Matching",
          "description": "Match transactions across networks and settlement files."
        },
        "networkFees": {
          "category": "Network Fees",
          "description": "Review and manage scheme and network fee charges."
        },
        "regulatoryReports": {
          "category": "Regulatory Reports",
          "description": "Generate and access reports required for regulatory compliance."
        },
        "customReconciliation": {
          "category": "Custom Reconciliation",
          "description": "Configure and run custom reconciliation workflows."
        },
        "programInvoicing": {
          "category": "Program Invoicing",
          "description": "Manage invoicing across your card programs."
        },
        "treasuryControl": {
          "category": "Treasury Control",
          "description": "Monitor and manage treasury positions and controls."
        }
      }
    },
    "disputesAndChargeback": {
      "title": "Disputes and Chargeback",
      "description": "Manage chargeback and dispute cases.",
      "section": {
        "title": "Chargeback and Disputes",
        "description": "Manage chargeback and dispute cases across all transactions."
      }
    },
    "webhooks": {
      "title": "Webhooks",
      "hostedEndpointsTab": "Hosted Endpoints",
      "webhookDetail": "Webhook Detail",
      "events": "Events",
      "editDetails": "Edit Details",
      "pingWebhook": "Ping Webhook",
      "updateWebhookStatus": "Update Webhook Status",
      "breadcrumbs": {
        "createNewWebhook": "Create New Webhook"
      },
      "steps": {
        "webhookDetails": "Webhook Details"
      },
      "notifications": {
        "pingHealthStatus": "Webhook {{webhookId}} Health Status",
        "pingStatusDescription": "Status: {{healthStatus}}",
        "statusUpdatedSuccess": "Webhook status updated successfully.",
        "createdSuccess": "Webhook created successfully.",
        "eventsUpdatedSuccess": "Webhook updated successfully.",
        "detailsUpdatedSuccess": "Webhook details updated successfully."
      },
      "createWebhook": {
        "newWebhookDetails": "New Webhook Details",
        "selectEvents": "Select Events",
        "productIdError": "Product ID cannot have more than one webhook associated with it.",
        "discardUnsavedChanges": "Discard Unsaved Changes?",
        "discardUnsavedChangesDescription": "You have unsaved changes. If you leave now, your changes will be lost. Are you sure you want to discard them?",
        "discardChanges": "Discard Changes",
        "keepEditing": "Keep Editing",
        "editEvents": "Edit Events"
      },
      "formFields": {
        "customHeaders": "Custom Headers",
        "url": "URL",
        "customHeadersOptional": "Custom Headers (optional)"
      }
    },
    "cardTransactionResultScreen": {
      "tabs": {
        "cardConfigurationDetails": "Card Configuration Details",
        "groupLevelSpendLimit": "Group - level Spend Limit",
        "tokenLevelSpendLimit": "Token - level Spend Limit",
        "cardHistory": "Card History",
        "paymentTokens": "Payment Tokens",
        "token16Digit": "Token (16-Digit)"
      },
      "groupLevelSpendLimit": {
        "dailyTitle": "Daily Limits",
        "cumulativeLimits1Title": "Cumulative Limits 1",
        "cumulativeLimits2Title": "Cumulative Limits 2",
        "subtitles": {
          "daily": "Today - {{date}}",
          "weekly": "Weekly - {{range}}",
          "monthly": "Monthly Limits - 01 - {{endDate}} - {{totalDays}} days",
          "rolling": "Total Days as Limit: {{days}} Days - {{range}}"
        }
      },
      "tokenLevelSpendLimit": {
        "showSpendLimitSettings": "Show Spend Limit Settings",
        "payIn": "Pay In",
        "payOut": "Pay Out",
        "spendAmountSpendLimit": "Spend amount / spend limit",
        "subCategory": "Sub Category: {{name}}",
        "notAvailable": "{{title}} is not available"
      },
      "labels": {
        "activationDate": "Activation Date",
        "automatedBillingOptOut": "Automated Billing Opt Out",
        "cardNetwork": "Card Network",
        "dateRange": "Date Range",
        "financialReversalRefunds": "Financial Reversal/Refunds",
        "inputMerchantLocation": "Input Merchant Location",
        "inputNote": "Input Note",
        "inputTraceId": "Input Trace ID",
        "linkedCards": "Linked Cards",
        "selectCardNetwork": "Select Card Network",
        "selectDateRange": "Select Date Range",
        "selectProcessingCode": "Select Processing Code",
        "selectType": "Select Type",
        "threddExpiryDate": "Thredd Expiry Date"
      },
      "totalItems": "Total {{count}} items",
      "errors": {
        "exportFailed": "An error has occurred while exporting transactions."
      },
      "dateRangeFilter": "Date Range: {{from}} - {{to}}"
    },
    "transactionDetails": {
      "posEntryDrilldown": {
        "title": "POS Entry Data",
        "incomingCode": "Incoming POS Entry Code",
        "decodedCode": "Decoded POS Entry Code"
      },
      "tabs": {
        "amountsFees": "Amounts & Fees",
        "merchantDetails": "Merchant & Other Details",
        "transactionLifecycle": "Transaction Lifecycle",
        "fleet": "Fleet"
      },
      "errors": {
        "insufficientPermissions": "Insufficient permissions",
        "insufficientPermissionsSubtitle": "Please ensure you have the correct role assigned."
      }
    },
    "transactionDetailsTab": {
      "labels": {
        "responseStatusDe039": "Response Status (DE039)",
        "transactionAmountDe004": "Transaction Amount (DE004)",
        "billingAmountDe006": "Billing Amount (DE006)",
        "settlementAmountDe005": "Settlement Amount (DE005)",
        "traceIdLifecycle": "Trace Id Lifecycle",
        "cardScheme": "Card Scheme",
        "totalFee": "Total Fee",
        "publicTokenWithValue": "Public Token: {{token}}",
        "cardImageAlt": "card"
      }
    },
    "transactionDetailsHeader": {
      "breadcrumbs": {
        "cardSearch": "Card Search",
        "transactionSearch": "Transaction Search",
        "transactionResults": "Transaction Results",
        "transactionDetailsSummary": "Transaction Details-Summary"
      },
      "transactionIdLabel": "Transaction ID:",
      "buttons": {
        "removeAuthorisation": "Remove Authorisation",
        "removeFromPFD": "Remove from PFD",
        "raiseDispute": "Raise Dispute",
        "sendToEHI": "Send to EHI",
        "resendToEHI": "Resend to EHI"
      },
      "dispute": {
        "modalTitle": "Confirm Dispute",
        "modalContent": "Are you sure you want to submit this transaction for dispute?",
        "submitting": "Submitting...",
        "successDescription": "Dispute submitted successfully",
        "errorNoDetails": "Transaction details not available",
        "errorFailedWithStatus": "Failed to submit dispute. Status: {{status}}",
        "errorFailed": "Failed to submit dispute. Please try again.",
        "disputeInitiated": "Dispute initiated from transaction detail"
      },
      "sendToEhiModal": {
        "title": "Send Transaction to EHI",
        "resendTitle": "Resend Transaction to EHI",
        "confirmationText": "Are you sure you want to send the transaction with ID {{transactionId}} to EHI?",
        "resendConfirmationText": "Are you sure you want to resend the transaction with ID {{transactionId}} to EHI?",
        "sending": "Sending...",
        "resending": "Resending...",
        "successDescription": "You have successfully sent transaction to EHI",
        "resendSuccessDescription": "You have successfully resent transaction to EHI",
        "errorDescription": "Failed to send to EHI",
        "errorWithException": "Failed to send transaction to EHI: {{error}}"
      }
    },
    "otherDetails": {
      "clickToReveal": "Click to reveal",
      "fields": {
        "messageType": "Message Type",
        "stanDe011": "STAN (DE011)",
        "transactionId": "Transaction I.D",
        "transactionOriginatingInstitution": "Transaction Originating Institution",
        "documentReferenceDe037": "Document Reference (DE037)",
        "authorisationCode": "Authorisation Code",
        "additionalResponseDataDe044": "Additional Response Data (DE044)",
        "additionalDataDe048": "Additional Data (DE048)",
        "avsResponse": "AVS Response",
        "fid": "FID",
        "threddPosData": "Thredd POS Data",
        "networkId": "Network I.D",
        "networkReferenceIdDe123": "Network Reference I.D (DE123)",
        "acquirerReferenceData": "Acquirer Reference Data",
        "iccDataDe055": "ICC Data (DE055)",
        "adviceReasonData": "Advice Reason Data",
        "taxId": "Tax I.D",
        "recordId": "Record I.D",
        "paymentTokenId": "Payment Token I.D",
        "responseSource": "Response Source",
        "responseReason": "Response Reason",
        "requestTime": "Request Time",
        "responseTime": "Response Time",
        "differenceInMs": "Difference (in milliseconds)",
        "functionCode": "Function Code",
        "additionalAuthorisationDataDgn": "Additional Authorisation Data DGN",
        "transactionDestinationIic": "Transaction Destination IIC",
        "recapNumber": "Recap Number",
        "recapDate": "Recap Date",
        "posConditionCodeDe25": "POS Condition Code (DE25)",
        "visaCodesDe063": "Visa Codes (DE063)",
        "binRefDe063": "Bin Ref (DE063)",
        "traceId": "Trace I.D"
      },
      "tooltips": {
        "posConditionCodeDe25": "The POS Condition Code (DE25) field is displaying the Transaction_Life_Cycle_ID_DE025 data for Authorisation transactions",
        "visaCodesDe063": "The Visa Codes (DE063) field is displaying the Transaction_Life_Cycle_ID_DE063 data for Presentment transactions",
        "binRefDe063": "The BIN Ref (DE063) field is displaying the Transaction_Life_Cycle_ID_DE063 data for Presentment transactions",
        "fullToken": "View full Token ID (16-Digit)"
      }
    },
    "contentAreaErrorFallback": {
      "defaultTitle": "Something went wrong",
      "defaultSubtitle": "An error occurred while loading content. Please refresh the page and try again.",
      "homePage": "Home page"
    },
    "cardActionsModals": {
      "shared": {
        "currentBalanceAmount": "Current Balance Amount",
        "enterAmount": "Enter amount",
        "selectAdjustmentTypePlaceholder": "Select adjustment type",
        "selectCreditDebitPlaceholder": "Select credit/debit",
        "selectLoadUnloadPlaceholder": "Select load/unload"
      },
      "balanceAdjustment": {
        "description": "Select adjustment type, credit/debit, and amount.",
        "creditDebit": "Credit / Debit",
        "adjustmentAmount": "Adjustment Amount",
        "validation": {
          "inputAboveZero": "Input a numeric value above 0 for the Balance Adjustment amount",
          "amountLargerThanAvailableBalance": "Adjustment amount cannot be larger than Available Balance",
          "amountGreaterThanBlocked": "Adjustment amount is greater than the blocked amount"
        }
      },
      "balanceTransfer": {
        "description": "Find sender and set an amount to transfer.",
        "senderCardPlaceholder": "Sender card number / token",
        "searchUsingThreddPublicToken": "Search using Thredd Public Token",
        "cardHolderName": "Card Holder Name",
        "validation": {
          "inputAboveZero": "Input a numeric value above 0 for the Transfer amount",
          "amountLargerThanAvailableBalance": "Transfer amount cannot be larger than Available Balance",
          "transferTokenSameAsCurrent": "Transfer Public Token cannot be same as current card",
          "noMatchingResult": "No matching result"
        }
      },
      "walletTransfer": {
        "description": "Select wallets to transfer balance.",
        "transferFrom": "Transfer from:",
        "transferTo": "Transfer to:",
        "debitAmount": "Debit Amount",
        "creditAmount": "Credit Amount",
        "getExchangeRateError": "Error getting exchange rate.",
        "gettingExchangeRate": "Getting exchange rate...",
        "selectWalletFirst": "Please select a Debit and Credit wallet to enable these fields."
      },
      "cardLoadUnload": {
        "description": "Select Card Load or Unload:",
        "cardLoadUnloadLabel": "Card Load/Unload"
      },
      "changeExpiryDate": {
        "title": "Change Expiry Date",
        "cardExpiry": "Card Expiry",
        "currentExpiryDate": "Current Expiry Date",
        "changeExpiryDateTo": "Change Expiry Date to",
        "selectDatePlaceholder": "Select date",
        "successMessage": "You have successfully changed the Thredd Expiry Date of this card from {{currentExpiryDate}} to {{newExpiryDate}}.",
        "successTitle": "Change Expiry Date action successful",
        "failureTitle": "Change Expiry Date action failed"
      },
      "changeCardStatus": {
        "title": "Change Card Status",
        "successMessage": "You have successfully changed the Card Status to {{status}}, see token {{publicToken}}.",
        "successTitle": "Change Card Status action successful",
        "failureTitle": "Change Card Status action failed"
      },
      "pinCvc2Services": {
        "chooseWhatToReset": "Choose what you want to reset",
        "chooseResetType": "Choose Reset Type",
        "resetAttemptsRemaining": "Reset Attempts Remaining",
        "onlinePin": "Online PIN",
        "offlinePin": "Offline PIN",
        "cvc2": "CVC2",
        "auditSuccessful": "Successful",
        "auditFailed": "Failed",
        "successMessage": "{{resetType}} tries have been reset and will take effect shortly.",
        "offlineSuccessMessage": "Offline PIN tries. A PIN script has been queued and will activate the next time the card is inserted into an EMV compliant terminal or chip and PIN machine. This does not apply to contactless or magnetic stripe transactions.",
        "allSuccessMessage": "Online PIN tries and CVC2 tries have been reset and will take effect shortly. Offline PIN tries. A PIN script has been queued and will activate the next time the card is inserted into an EMV compliant terminal or chip and PIN machine. This does not apply to contactless or magnetic stripe transactions.",
        "successTitle": "PIN & CVC2 Services action successful",
        "failureTitle": "PIN & CVC2 Services action failed"
      },
      "editCardholderDetails": {
        "editSuccessful": "Cardholder Details edit successful",
        "editFailed": "Cardholder Details edit failed"
      }
    },
    "cardDetailsHeader": {
      "seeAllWalletDetails": "See All Wallet Details",
      "viewCurrencyWallets": "View Currency Wallets",
      "tokenBreadcrumb": "Token {{publicToken}}",
      "cardholder": "Cardholder"
    },
    "cardActions": {
      "title": "Card Actions",
      "pinCvc2Services": "PIN & CVC2 Services",
      "editCardholderDetails": "Edit Cardholder Details",
      "editCardConfigurations": "Edit Card Configurations",
      "balanceTransfer": "Balance Transfer",
      "walletTransfer": "Wallet Transfer",
      "actionUnavailable": "Action Unavailable",
      "onlyAvailableOnPrimaryWallet": "Only available on Primary Wallet"
    },
    "balanceLabels": {
      "blockedAmount": "Blocked Amount"
    },
    "ach": {
      "labels": {
        "effectiveEntryDate": "Effective Entry Date"
      },
      "transactionDetailsDrawer": {
        "fields": {
          "transferSpeed": "Transfer Speed",
          "transferAmount": "Transfer Amount",
          "individualName": "Individual Name",
          "returnCode": "Return Code",
          "receivingDfiAccountType": "Receiving DFI Account Type",
          "originatingBank": "Originating Bank",
          "individualAccount": "Individual Account",
          "paymentAuthorizationDetails": "Payment Authorization Details",
          "originatorName": "Originator Name"
        }
      },
      "moneyMovement": {
        "title": "Money Movement",
        "subtitle": "ACH Transaction Search",
        "referenceNumberDescription": "Unique ID - 15 digits",
        "filters": {
          "nameTitle": "Select Name",
          "statusTitle": "Select Status"
        }
      },
      "errors": {
        "failedToLoadTransactions": "Failed to load transactions"
      }
    },
    "cardsSearch": {
      "columns": {
        "token16Digits": "Token (16-Digits)",
        "cardStatus": "Card Status",
        "postCode": "Post Code",
        "customerReferenceNumber": "Customer Reference Number"
      },
      "errors": {
        "customerReferenceNotFound": "Customer Reference not found",
        "productIdNotFound": "Product ID not found"
      },
      "customerDetailsFilter": {
        "labels": {
          "postcodeZipcode": "Postcode / Zipcode"
        },
        "errors": {
          "maxDateAllowed": "Maximum date allowed is {{date}}",
          "minDateAllowed": "Minimum date allowed is {{date}}"
        },
        "alerts": {
          "advancedSearchRequirement": "For the Advanced Search, you must provide a First Name, Last Name and an additional field."
        }
      }
    },
    "fleet": {
      "labels": {
        "commodityCode": "Commodity Code",
        "quantity": "Quantity",
        "unitOfMeasure": "Unit Of Measure",
        "unitCost": "Unit Cost",
        "discountPerLineItem": "Discount Per Item",
        "lineItemTotal": "Line Item Total",
        "vatTaxAmount": "VAT Tax Amount",
        "vatRate": "VAT Rate"
      }
    },
    "sponsorGuard": {
      "allProgrammeManagers": "All Programme Managers",
      "title": "Sponsor Guard",
      "portfolioCurrency": {
        "button": "Portfolio Currency:",
        "title": "Portfolio Currency",
        "description": "Changes apply immediately across the entire portfolio. Existing limits are converted to the new currency using the current exchange rate and rounded to the nearest whole amount.",
        "selectLabel": "Select Portfolio Currency",
        "apply": "Apply Currency",
        "notSet": "Not Set"
      },
      "welcomeModal": {
        "title": "Welcome to Thredd Portal",
        "description": "SponsorGuard brings your Programme Managers together in one place, making it easier to monitor activity, track performance and maintain oversight across your portfolio.",
        "prompt": "Before you get started, choose the currency you'd like to use to view your portfolio",
        "currencyTooltip": "This currency applies to your entire portfolio. Converted values are approximate. You can change the currency at any time in Configuration.",
        "submit": "Get Started"
      },
      "actions": {
        "freezeClient": "Freeze Programme Manager",
        "unfreezeClient": "Unfreeze Programme Manager"
      },
      "dashboard": {
        "title": "Portfolio",
        "subtitle": "Monitor your sponsored programme portfolio in one place",
        "subtitleTooltip": "Data may be delayed by up to 30 minutes.",
        "currentSpend": "Current Spend",
        "programmeManagersToggleLabel": "Programme Managers:",
        "unmonitoredProgrammeManagers": {
          "title": "Unmonitored Programme Managers ({{count}})"
        },
        "unmonitoredBanner": {
          "title": "{{percent}} of Your Programme Managers Are Being Monitored",
          "description": "Set monitoring limits and thresholds for your pending Programme Managers to include them in your dashboard metrics and support ongoing compliance oversight.",
          "configure": "Configure Programme Managers"
        },
        "portfolioOverview": {
          "title": "Portfolio Overview",
          "titleTooltip": "Estimated based on available data. Actual spend may vary due to processing delays, exchange rates, and other factors.",
          "totalSpend": "Estimated Spend for All Programme Managers",
          "estimatedRemaining": "Estimated Remaining",
          "spent": "Spent",
          "remaining": "Remaining"
        },
        "programmeManagersStatus": {
          "title": "Programme Managers by Status"
        },
        "totalDeclines": {
          "title": "Declines Overview",
          "declinedTransactionAmount": "Declined Transaction Amount",
          "transactionsDeclined": "Transactions Declined",
          "programmeManagersAffected": "Programme Managers Affected",
          "stats": "{{count}} of {{total}} ({{percent}}%)"
        },
        "programmeManagersOverview": {
          "title": "Programme Managers Overview",
          "viewAll": "See All Programme Managers",
          "columns": {
            "programmeStatus": "Programme Status",
            "currentSpend": "Current Spend ({{currency}})",
            "limitUsedPercent": "% of Threshold Used",
            "declinesNumber": "Declines Number",
            "declinesAmount": "Declines Amount ({{currency}})"
          }
        }
      },
      "client": {
        "title": "Programme overview",
        "bin": "BIN: {{binRange}}",
        "pendingRequestTooltip": "Freeze request pending approval. Programme Manager and products remain active.",
        "actions": {
          "freezeProduct": "Freeze Product",
          "unfreezeProduct": "Unfreeze Product",
          "seeDeclineTransactions": "See decline transactions"
        },
        "overview": {
          "title": "Programme Manager Overview",
          "dayEnd": "Programme Day-End: {{time}}",
          "dayEndTooltip": "Daily limit resets at the programme’s configured day-end time. All times are in UTC.",
          "ofLimit": "of {{limit}}",
          "totalTransactions": "Total Transactions",
          "declined": "{{declined}} declined",
          "collateral": "Collateral",
          "productInsights": "Product Insights",
          "spendByProducts": "Spend by Products",
          "productPerformance": "Product Performance",
          "estimatedDailySpend": "Estimated Daily Spend",
          "columns": {
            "declined": "Declined"
          }
        },
        "configuration": {
          "dailySpendingLimit": "Daily Spending Limit",
          "collateralRatioWarning": "Collateral Ratio Warning",
          "viewRuleset": "View Ruleset",
          "dayEnd": "Day-End",
          "dayEndUtc": "Day-End UTC",
          "monitoring": "Monitoring"
        },
        "notifications": {
          "freezeClient": "Your request to freeze this client has been submitted successfully.",
          "unfreezeClient": "Your request to unfreeze this client has been submitted successfully.",
          "freezeProduct": "Your request to freeze {{product}} has been submitted successfully.",
          "unfreezeProduct": "Your request to unfreeze {{product}} has been submitted successfully.",
          "monitoringStarted": "This client is now monitored by Sponsor Guard.",
          "monitoringStopped": "This client is no longer monitored by Sponsor Guard."
        }
      },
      "configuration": {
        "searchPlaceholder": "Search Programme Managers",
        "form": {
          "title": "Configure Monitoring for {{name}}",
          "steps": {
            "details": "Programme Manager Configuration"
          },
          "placeholders": {
            "amount": "Input Amount",
            "selectTime": "Select time"
          },
          "tooltips": {
            "emailAddress": "We’ll email the Programme Manager if they or any of their products are frozen or unfrozen.",
            "monitoring": "Monitoring displays metrics for the Programme Managers based on this ruleset. If monitoring is turned off, their metrics won’t be shown. You can turn monitoring on or off at any time.",
            "dayEndUtc": "The time the Programme Manager’s daily monitoring period ends. Enter the time in UTC."
          },
          "validation": {
            "dailySpendLimitRequired": "Please enter a daily spending limit",
            "collateralRatioWarningRequired": "Please enter a collateral ratio warning",
            "dayEndRequired": "Please select a day-end time"
          },
          "buttons": {
            "reviewRuleset": "Review Ruleset"
          },
          "startMonitoring": {
            "description": "Configure the required monitoring limits and thresholds to include this Programme Manager in your dashboard metrics and ongoing monitoring.",
            "submit": "Save and Start Monitoring"
          }
        },
        "notifications": {
          "updatedTitle": "Ruleset updated",
          "updatedDescription": "The ruleset {{name}} has been updated successfully.",
          "monitoringNotUpdatedTitle": "Ruleset saved, monitoring not updated",
          "monitoringNotUpdatedDescription": "The ruleset {{name}} was saved but monitoring could not be changed: {{message}}"
        },
        "columns": {
          "programmeManager": "$t(portal:labels.programmeManager)",
          "dailySpendLimit": "Daily Spend Limit ({{currency}})"
        }
      },
      "clients": {
        "title": "Programme Managers",
        "columns": {
          "binRange": "BIN Range",
          "dailySpend": "Daily Spend ({{currency}})",
          "limitUsedPercent": "% of Limit Used",
          "declineRate": "Decline Rate",
          "programmeDayEnd": "Programme Day-End",
          "sponsorGuardStatus": "SponsorGuard Status"
        },
        "status": {
          "withinLimit": "Within Limit",
          "approachingLimit": "Approaching Limit"
        },
        "actions": {
          "freeze": "Freeze",
          "unfreeze": "Unfreeze",
          "startMonitoring": "Start Monitoring"
        },
        "freezeModal": {
          "description": "You are about to freeze this individual program. Please provide a reason for this action.",
          "reasonRequired": "Please select a reason",
          "notice": {
            "title": "Important Notice About Your Freeze Request",
            "description": {
              "product": "Submitting this request will not freeze the product immediately. If approved, the product will be frozen and transactions will be blocked. This action may have legal implications.",
              "programmeManager": "Submitting this request will not freeze the Programme Manager immediately. If approved, the Programme Manager will be frozen and transactions will be blocked. This action may have legal implications."
            }
          },
          "reasons": {
            "spendLimitBreached": "Spend Limit Breached",
            "approachingLimit": "Approaching Limit (Precautionary Freeze)",
            "suspiciousActivity": "Suspicious Activity"
          }
        },
        "unfreezeModal": {
          "description": "You are about to unfreeze this individual program. Please provide a reason for this action."
        },
        "modal": {
          "affectedClient": "Affected Client",
          "affectedProducts": "Affected Product(s)",
          "noteLabel": "Note (optional)",
          "notePlaceholder": "Textarea",
          "submit": "Submit for Approval",
          "startMonitoring": {
            "title": "Start Monitoring This Programme Manager?",
            "description": "Monitoring tracks this Programme Manager against the assigned ruleset. You can start monitoring at any time by using their settings.",
            "rulesetName": "Ruleset Name",
            "confirm": "Start Monitoring This Programme Manager"
          }
        },
        "notifications": {
          "freezeTitle": "Freeze request submitted",
          "freezeDescription": "The freeze request for {{programManager}} has been submitted for approval.",
          "unfreezeTitle": "Unfreeze request submitted",
          "unfreezeDescription": "The unfreeze request for {{programManager}} has been submitted for approval.",
          "monitoringStartedDescription": "Programme Manager {{programManager}} is now monitored."
        },
        "errors": {
          "loadFailed": "We couldn't load the client list. Please try again."
        }
      },
      "approvals": {
        "title": "Approvals",
        "subtitle": "Requests awaiting action ({{count}})",
        "columns": {
          "requestedDate": "Request Date",
          "requester": "Requester",
          "affectedProgrammeManager": "Affected Programme Manager"
        },
        "targetType": {
          "programmeManager": "$t(portal:labels.programmeManager)"
        },
        "status": {
          "awaitingApproval": "Awaiting approval"
        },
        "actions": {
          "approve": "Approve",
          "reject": "Reject"
        },
        "actionModal": {
          "approveTitle": "Approve Request?",
          "requestedBy": "Requested by",
          "approveDescription": "Review the request details before approving.",
          "freezeNotice": {
            "title": "Important Notice About Your Freeze Approval",
            "description": {
              "product": "Approving this request will immediately freeze the product and prevent transactions from being processed. This action may have legal implications.",
              "programmeManager": "Approving this request will immediately freeze the Programme Manager and prevent transactions from being processed. This action may have legal implications."
            }
          },
          "rejectTitle": "Decline",
          "rejectDescription": "Provide a reason to help the requester understand why the request was rejected."
        },
        "notifications": {
          "approvedTitle": "Request Approved",
          "approvedFrozenDescription": "{{target}} Frozen.",
          "approvedUnfrozenDescription": "{{target}} Unfrozen.",
          "approvedPartialTitle": "Request approved with errors",
          "approvedPartialDescription": "The request was approved but could not be applied to: {{failed}}.",
          "rejectedTitle": "Request Declined",
          "rejectedFreezeDescription": "{{target}} freeze request declined.",
          "rejectedUnfreezeDescription": "{{target}} unfreeze request declined."
        },
        "ownRequestTooltip": "You cannot decide on a request you submitted.",
        "emptyState": "No Request Awaiting for you"
      },
      "auditLogs": {
        "title": "Audit Logs",
        "columns": {
          "eventId": "Event ID"
        },
        "actions": {
          "freeze_requested": "Freeze Requested",
          "freeze_approved": "Freeze Approved",
          "freeze_rejected": "Freeze Rejected",
          "freeze_applied": "Freeze Applied",
          "freeze_apply_failed": "Freeze Failed",
          "unfreeze_requested": "Unfreeze Requested",
          "unfreeze_approved": "Unfreeze Approved",
          "unfreeze_rejected": "Unfreeze Rejected",
          "unfreeze_applied": "Unfreeze Applied",
          "unfreeze_apply_failed": "Unfreeze Failed"
        },
        "filters": {
          "allFreeze": "All Freeze",
          "allUnfreeze": "All Unfreeze",
          "requested": "Requested",
          "applied": "Applied"
        },
        "emptyState": "No audit logs found"
      },
      "feedbackWidget": {
        "sentiment": {
          "question": "Overall, how satisfied are you with the Thredd Sponsorguard?"
        },
        "rating": {
          "easeOfFindingInformation": "Ease of finding information",
          "clarityOfInformation": "Clarity of information",
          "visibilityOfSpendAndApprovals": "Visibility of spend and approvals",
          "overallDashboardExperience": "Overall dashboard experience"
        },
        "comment": {
          "placeholder": "Tell us about anything that could make your Sponsorguard experience better."
        }
      }
    },
    "aiChat": {
      "launcher": "Ask Thredd AI",
      "title": "Thredd AI assistant",
      "newConversation": "New conversation",
      "close": "Close assistant",
      "resize": "Resize assistant",
      "inputPlaceholder": "Ask about your cards, transactions or products…",
      "send": "Send message",
      "thinking": "Thinking…",
      "disclaimer": "AI responses can be inaccurate. Check important information.",
      "toolsUsed": "Sources used",
      "empty": {
        "title": "How can I help?",
        "description": "Ask a question about your programme's cards, transactions or products."
      },
      "suggestions": {
        "availableProducts": "Which products are available to my programme?",
        "cardBalance": "What's the balance and status of card "
      },
      "errors": {
        "badRequest": "That message couldn't be sent. Try rephrasing it.",
        "unauthorized": "Your session isn't authorised for the assistant. Try signing in again.",
        "toolsForbidden": "You don't have permission to access the data needed to answer that.",
        "rateLimited": "Too many requests. Wait a moment and try again.",
        "toolsUnavailable": "Thredd data services are unavailable right now. Try again later.",
        "modelUnavailable": "The assistant is unavailable right now. Try again later.",
        "internalError": "Something went wrong. Try again.",
        "networkError": "Couldn't reach the assistant. Check your connection and try again."
      }
    }
  }
}
